import request from './request'

// 获取公开课列表数据
export function getGkkList(page, pagesize, keywords, type) {
  const url = '/course/getpubliccourselist'
  let params = {
    page: page,
    pagesize: pagesize,
    type: type
  }
  if (typeof keywords !== 'undefined') {
    params.keywords = keywords
  }
  return request.get(url, {
    params: params
  })
}



// WEBPACK FOOTER //
// ./src/api/gkk.js